import { User } from "@/src/data/allTypes";
import { getImgUrl } from "@/src/utils/utils";

export function UserAvatar({
  user,
  size,
}: {
  user?: User | null | undefined;
  size?: number;
}) {
  console.log("getImgUrl(user?.profilePic) ",getImgUrl(user?.profilePic) )
  return (
    <div className="avatar" style={{ height: size, width: size }}>
      <img
        src={`${getImgUrl(user?.profilePic) || `/images/user-icon-gray.png`}`}
        alt=""
      />
    </div>
  );
}
